var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUpload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 14,
  viewBox: "0 0 12 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12 12v2H0v-2zM6.679.31 10 3.963v.508a.99.99 0 0 1-.992.993H8.5L7 3.33v6.634H5V3.33L3.5 5.464h-.508A.99.99 0 0 1 2 4.471v-.508L5.321.31a.897.897 0 0 1 1.358 0"
})));
export default SvgUpload;